import React, {  useState } from "react"
import styled from "styled-components"
import { graphql, Link } from "gatsby"
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Layout from "../layouts";
import Seo from "../components/seo"
import {
  BreadCrumb,
  MarkdownContent,
  Section,
  GridPanel,
  GridItemPanel,
  GridLeftPanel,
  GridRightPanel,
  Container,
  ListBadge,
  ListItemBadge,
  Badge
} from "../components/Section"
import { SidebarGroup, SidebarSticky, SidebarCard, SidebarCardBody} from "../components/Sidebar"
import {ColorOptions, ColorNavTabs, ColorNavitem, ColorTabContent, ColorItem, Color } from "../components/ColorStyle"
import { FormTitle } from "../components/FormStyle"
import WidthIcon from "../components/Icons/WidthIcon"
import HeightIcon from "../components/Icons/HeightIcon"
import LengthIcon from "../components/Icons/LengthIcon"
import WarrantyCard from '../components/WarrantyCard';
import PanelCard from '../components/PanelCard';
import ApplyFinancingCard from '../components/ApplyFinancingCard';
import GetCustomQuoteForm from '../components/Forms/GetCustomQuote';
import ProductButtons from '../components/ProductButtons';
import Expandable from "../components/Expandable";
import CheckMarkIcon from "../components/Icons/CheckMarkIcon";


const ProductCard = styled.div`
  position:relative;
  margin-bottom:30px;
  @media(min-width:992px){
	  padding-left:20px;
  }

	.gatsby-image-wrapper {
		width: 100%;
    height: 100%;
    overflow:hidden;
    border-radius: 10px;
    @media(min-width:992px){
		  border-radius: 20px;
    }
	}
`
const ProductName = styled.h1`
  margin-bottom:5px;
`
const ProductDsc = styled.div`
  p{
    color:#666;
    font-size:16px;
    line-height:26px;
  }
`
const ProducHelpText = styled.div`
  font-size:12px;
  line-height:20px;
  color:#666;
  margin-bottom:15px;

`
const ProducSku = styled.div`
  position: absolute;
  z-index:1;
  top:20px;
  left:0;
  font-size:16px;
  line-height:26px;
  color:#fff;
  background-color: #574C4C;
  padding:5px 10px;
  @media(min-width:992px){
    top:30px;
    left:-15px;
    --s: 1.6em; /* the ribbon size */
    --d: .6em;  /* the depth */
    --c: .6em;  /* the cutout part */
    
    padding: 0 var(--c) var(--d) calc(var(--s) + .5em);
    line-height: 1.8;
    background: conic-gradient(at left  var(--s) bottom var(--d),#0000 25%,#0008 0 37.5%,#938888 0);
    clip-path: polygon(calc(100% - var(--c)) 0,  var(--s) 0,var(--s) var(--d),0 var(--d),var(--c) calc(50% + var(--d)/2),0 100%,calc(var(--s) + var(--d)) 100%,calc(var(--s) + var(--d)) calc(100% - var(--d)),calc(100% - var(--c)) calc(100% - var(--d)),100% calc(50% - var(--d)/2));
    width: fit-content;
    background-color: #574C4C;
  }
  span{font-weight:400; color:#D0D0D0;}
  strong{font-weight:500}
`
const FinRto = styled.div`
  display:flex;
  flex-wrap:wrap;
  align-items:center;
  margin:0 -15px 15px -15px;
`
const FinItemRto = styled.div`
  position:relative;
  padding:0 15px;
  display:flex;
  flex-wrap:wrap;
  align-items:center;
  .icon{
    display:flex;
    flex-wrap:wrap;
    align-items:center;
    height:26px;
    @media(min-width:992px){
      height:30px;
    }
    > svg{
      fill:#A1A1A1;
    }
    + .text{
      margin-left:10px;
    }
  }
  .text{
    color:#574C4C;
    font-size:16px;
    line-height:26px;
    @media(min-width:992px){
      line-height:30px;
      font-size:18px;
    }
  }
`
const Dimensions = styled.div`
  position: relative;
  display: flex;
  flex-wrap:wrap;
  justify-content:space-between;
  align-items: center;
  border-radius: 8px;
  background: #fff;
  border:1px solid #929292;
  width: fit-content;
  margin:-24px auto 0 auto;
  padding: 8px 10px;
  @media(min-width:992px){
    padding: 12px 20px;
    margin:-34px auto 0 auto;
  }
`
const DimensionItem = styled.div`
  display: flex;
  flex-wrap:wrap;
  align-items: center;
  color:#7E7E7E;
  padding:0 10px;
  @media(min-width:992px){
    padding:0 15px;
  }
  .icon{
    + .text{margin-left:2px}
  }
  .text{}
  .label{
    display: block;
    font-size: 10px;
    line-height: 14px;
    margin-bottom: 0;    
  }
  .value{
    display: block;
    font-size: 18px;
    line-height: 24px;
  }
`
const ListCardGroup = styled.div`
  display: flex;
  flex-wrap:wrap;
  margin:0 -10px;
  @media(min-width:768px){
    margin:0 -15px;
  }
`
const ListItemCard = styled.div`
  position:relative;
  width:100%;  
  padding:0 10px;
  @media(min-width:992px){
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
    padding:0 15px;
  }
`

const ProductTemplate = ({ data, location }) => {
  const pageData = data.contentfulProduct;
  // const products = data?.allContentfulProduct?.edges || [];
  const [colorOption, setColorOption] = useState("siding");
  // const settings = {
  //   centerMode: true,
  //   centerPadding: 0,
  //   slidesToShow: 3,
  //   arrows: false,
  //   initialSlide: 0,
  //   infinite: true,
  //   focusOnSelect: true,
  //   dots: false,
  //   responsive: [
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 1
  //       }
  //     },
  //     {
  //       breakpoint: 1200,
  //       settings: {
  //         slidesToShow: 2
  //       }
  //     }
  //   ]
  // };

  //const sliderRef = useRef(null);
  
  // const goPrev = () => {
  //   sliderRef.current.slickPrev();
  // }

  // const goNext = () => {
  //   sliderRef.current.slickNext();
  // }

  // const relatedProducts = products.filter(p => p.node.category.name === pageData.category.name);
  const plainTextDescription = pageData.description.childMarkdownRemark.html.replace(/<[^>]+>/g, '');

  const schema = { 
    "@context": "https://schema.org/",  
    "@type": "Product",  
    "name": pageData.name,
    "url": pageData.url,
    "image":`https:${pageData.image.file.url}`,
    "description":plainTextDescription,
    "brand": { 
      "@type": "Brand", 
      "name": "Buildings And More" 
    }, 
    "sku": pageData.sku, 
    "aggregateRating": { 
      "@type": "AggregateRating", 
      "ratingValue": "4.8", 
      "ratingCount": "228" 
    } 
  } 
  console.log(schema, 'Schema Test');
  return(
    <Layout footerCta location={location}>
      <Seo title={pageData.metaTitle} description={pageData.metaDescription} schemaMarkup={schema} />
      <Section ept="160px" xpt="140px" pt="80px">
        <Container className="1430">
          <BreadCrumb mb="30px"><Link to="/">Home</Link><span>{pageData.name}</span></BreadCrumb>
          <GridPanel>
            <GridItemPanel>
              <ProductCard>
                <GatsbyImage image={getImage(pageData.image.gatsbyImageData)} alt={pageData.name} />
                <ProducSku><span>SKU:</span> <strong>{pageData.sku}</strong></ProducSku>
                <Dimensions>
                  <DimensionItem>
                    <span className="icon"><WidthIcon /></span>
                    <span className="text">
                      <small className="label">Width</small>
                      <strong className="value">{pageData.width}</strong>
                    </span>
                  </DimensionItem>
                  <DimensionItem>
                    <span className="icon"><LengthIcon /></span>
                    <span>
                      <small className="label">Length</small>
                      <strong className="value">{pageData.length}</strong>
                    </span>
                  </DimensionItem>
                  {pageData.category?.name !== "Gazebos" && pageData.subCategory?.name !== "Metal Barns" && (
                    <DimensionItem>
                      <span className="icon"><HeightIcon /></span>
                      <span>
                        <small className="label">Height</small>
                        <strong className="value">{pageData.height}</strong>
                      </span>
                    </DimensionItem>
                  )}
                </Dimensions>
              </ProductCard>
            </GridItemPanel>
            <GridItemPanel>
              <ProductName>{pageData.name}</ProductName>              
              <ProductDsc><div dangerouslySetInnerHTML={{__html: pageData.description.childMarkdownRemark.html}} /></ProductDsc>
              <ProducHelpText>{pageData.pricingLabel}</ProducHelpText>
              <FinRto>
                {pageData.rto && (
                  <FinItemRto><span className="icon"><CheckMarkIcon /></span><span className="text">RTO</span></FinItemRto>
                )}
                {pageData.financing && (
                  <FinItemRto><span className="icon"><CheckMarkIcon /></span><span className="text">Financing</span></FinItemRto>
                )}
              </FinRto>
              <ProductButtons />
            </GridItemPanel>
          </GridPanel>
        </Container>
      </Section>

      <Section bgColor="#f7f5f5">
        <Container>
          <GridPanel>
            <GridLeftPanel>
              <Expandable title="Standard Features" defaultExpanded>
                <MarkdownContent>
                  <ul>
                    {pageData.standardFeatures.map((item, i) => (
                      <li key={`standard-feature-${i}`}>
                        <p>{item.content}</p>
                      </li>
                    ))}
                  </ul>
                </MarkdownContent>
              </Expandable>
              {pageData.category.name === "Portable Buildings" && (
                <Expandable title="Building Dimension & Starting Price">
                  <MarkdownContent>
                    <div>{pageData.buildingDimensionDescription}</div>
                    <ListBadge>
                      {pageData.buildingDimensionStartingPrice.map((dp, i) => (
                        <ListItemBadge><Badge key={`dimensionPrice-${i}`}>{dp.content}</Badge></ListItemBadge>
                      ))}
                    </ListBadge>
                  </MarkdownContent>
                </Expandable>
              )}
              <Expandable title="Options">
                <MarkdownContent dangerouslySetInnerHTML={{ __html: pageData.options.childMarkdownRemark.html }} />
              </Expandable>
              <Expandable title="Extra Features">
                <GridPanel>
                  <GridItemPanel>
                    <MarkdownContent>
                      <ul>
                        {pageData.extraFeatures.map((ef, i) => {
                          if (i < (pageData.extraFeatures.length / 2)) {
                            return (
                              <li key={`extra-feature-${i}`}>
                                <p>{ef.content}</p>
                              </li>
                            )
                          } else {
                            return true;
                          }
                        })}
                      </ul>
                    </MarkdownContent>
                  </GridItemPanel>
                  <GridItemPanel>
                    <MarkdownContent>
                      <ul>
                        {pageData.extraFeatures.map((ef, i) => {
                          if (i >= (pageData.extraFeatures.length / 2)) {
                            return (
                              <li key={`extra-feature-${i}`}>
                                <p>{ef.content}</p>
                              </li>
                            )
                          } else {
                            return true;
                          }
                        })}
                      </ul>
                    </MarkdownContent>
                  </GridItemPanel>
                </GridPanel>
              </Expandable>
              <Expandable title="Color Options">
                <p>{pageData.colorOptionsDescription}</p>
                <ColorOptions>
                  <ColorNavTabs>
                    <ColorNavitem
                      active={colorOption === "siding" ? "true" : "false"}
                      onClick={() => setColorOption("siding")}
                    >
                      Siding Colors
                    </ColorNavitem>
                    <ColorNavitem
                      active={colorOption === "trim" ? "true" : "false"}
                      onClick={() => setColorOption("trim")}
                      ml="20px"
                    >
                      Trim Colors
                    </ColorNavitem>
                  </ColorNavTabs>

                  {colorOption === "siding" && (
                    <ColorTabContent>
                      {pageData.sidingColors.map((sc, i) => (
                        <ColorItem key={`sidingColor-${i}`}>
                          <Color>
                            <GatsbyImage image={getImage(sc.color.gatsbyImageData)} alt={sc.name} />
                            <p>{sc.name}</p>
                          </Color>
                        </ColorItem>
                      ))}
                    </ColorTabContent>
                  )}
                  {colorOption === "trim" && (
                    <ColorTabContent>
                      {pageData.trimColors.map((tc, i) => (
                        <ColorItem key={`trimColor-${i}`}>
                          <Color>
                            <GatsbyImage image={getImage(tc.color.gatsbyImageData)} alt={tc.name} />
                            <p>{tc.name}</p>
                          </Color>
                        </ColorItem>
                      ))}
                    </ColorTabContent>
                  )}
                </ColorOptions>
              </Expandable>
            </GridLeftPanel>
            <GridRightPanel>
              <SidebarSticky className="sidebar isSticky">
                <SidebarGroup>
                  <SidebarCard className="sidebar-card">
                    <SidebarCardBody className="sidebar-cardbody">
                      <FormTitle className="form-title" textAlign="left">Get Your Custom Quote</FormTitle>
                      <GetCustomQuoteForm location={location} />
                    </SidebarCardBody>
                  </SidebarCard>
                </SidebarGroup>
              </SidebarSticky>
            </GridRightPanel>
          </GridPanel>
        </Container>
      </Section>    

      <Section epb="0" xpb="0" pb="0">
        <Container maxWidth="1200px">
           <ListCardGroup>
              <ListItemCard><ApplyFinancingCard /></ListItemCard>
              {(pageData.category.name == "Red Iron Buildings") ?  <ListItemCard><PanelCard /></ListItemCard> : <ListItemCard><WarrantyCard /></ListItemCard>}
           </ListCardGroup>
        </Container>
      </Section>
      {/* <RelatedProducts>
        <SectionPageTitle textAlign="center">Related Products</SectionPageTitle>
        <SliderWrapper>
          <Slider {...settings} ref={sliderRef}>
            {relatedProducts.map((product) => (
              <ProductCardWrapper key={product.node.name}>
                <ProductCard data={product.node} />
              </ProductCardWrapper>
            ))}
          </Slider>
          <SliderPrevBtn onClick={goPrev}><span>←</span></SliderPrevBtn>
          <SliderNextBtn onClick={goNext}><span>→</span></SliderNextBtn>
        </SliderWrapper>
      </RelatedProducts> */}
    </Layout>
  )
}

export default ProductTemplate;

export const pageQuery = graphql`
  query productTemplateQuery($id: String!) {
    contentfulProduct(id: { eq: $id }) {
      metaTitle
      metaDescription
      category {
        name
      }
      subCategory {
        name
      }
      name
      url
      sku
      width
      length
      height
      image {
        gatsbyImageData(quality: 80)
        file {
          url
        }
      }
      startingPrice
      downPayment
      rto
      financing
      description {
        childMarkdownRemark {
          html
        }
      }
      pricingLabel
      standardFeatures {
        content
      }
      buildingDimensionDescription
      buildingDimensionStartingPrice {
        content
      }
      options {
        childMarkdownRemark {
          html
        }
      }
      extraFeatures {
        content
      }
      colorOptionsDescription
      sidingColors {
        name
        color {
          gatsbyImageData(quality: 80)
        }
      }
      trimColors {
        name
        color {
          gatsbyImageData(quality: 80)
        }
      }
    }
    allContentfulProduct {
      edges {
        node {
          category {
            name
          }
          subCategory {
            name
          }
          name
          sku
          width
          length
          height
          image {
            gatsbyImageData(placeholder: BLURRED, quality: 50)
          }
          startingPrice
          downPayment
          url
        }
      }
    }
  }
`